var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8704 4.31147H20.0847C21.426 4.31147 22.5133 5.44254 22.5133 6.83779V23.2588C22.5133 24.6541 21.426 25.7852 20.0847 25.7852H7.94188C6.60061 25.7852 5.51331 24.6541 5.51331 23.2588V6.83779C5.51331 5.44254 6.60061 4.31147 7.94188 4.31147H9.15616M18.8704 4.31147C18.8704 5.70672 17.7831 6.83779 16.4419 6.83779H11.5847C10.2435 6.83779 9.15616 5.70672 9.15616 4.31147M18.8704 4.31147C18.8704 2.91623 17.7831 1.78516 16.4419 1.78516H11.5847C10.2435 1.78516 9.15616 2.91623 9.15616 4.31147M9.15621 15.6799H10.9776L12.7991 18.8378L15.2276 12.522L17.0491 16.3115H18.8705",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyHistory);
export default __webpack_public_path__ + "static/media/family_history.793518c0796c65439becbe5085271783.svg";
export { ForwardRef as ReactComponent };